export const CHOICE = {
  YES: 'YES',
  NO: 'NO',
};
export const LABEL_WIDTH = 60;
export const MAX_LENGTH = 200;
export const SUED_PARTY_DRIVER_ID = 2;
